import _ from 'lodash';

const AUTHORITY_TEMPLATE_LIST = "111"
const AUTHORITY_TEMPLATE_CONTROL = "112"
const AUTHORITY_MY_CREATIVE = "121"
const AUTHORITY_STAFF_ADD = "131"
const AUTHORITY_COMPANY_ADMIN_ADD = "132"
const AUTHORITY_COMPANY_USER_ADD = "133"
const AUTHORITY_CLIENT_ADD = "134"
const AUTHORITY_ELEMENT_ADD = "135"
const AUTHORITY_DATA_REPORT = "141"
const AUTHORITY_MATERIAL_CONTROL = "151"

export const hasAuth = (val) => {
    try {
        const authority = JSON.parse(localStorage.getItem("authority"));
        if (authority) {
            return _.indexOf(authority, val) > -1
        }
    } catch (e) {
        
    }
};